function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import styled, { css } from 'styled-components';
import PropTypes from 'prop-types';
import { strictSpace } from '../../utils';
import styledPropTypes from '@styled-system/prop-types';
import * as mixins from '../Mixins/Mixins';
/**
 * Renders an inline StatusTag.
 */

var StatusTag = styled.span.withConfig({
  displayName: "StatusTag",
  componentId: "sc-1kawjet-0"
})(["", " position:relative;white-space:nowrap;display:inline-flex;align-items:center;height:", ";margin:0;padding:0 ", ";", ";line-height:1;color:", ";border:1px solid ", ";background-color:", ";border-radius:2em;text-rendering:optimizeLegibility;text-transform:uppercase;", " &:last-child{margin-right:0;}&::before{content:'';display:inline-block;vertical-align:text-bottom;margin-right:0.5em;width:0.6em;height:0.6em;border-radius:1.2em;", ";background-size:contain;}"], mixins.tagline, function (_ref) {
  var theme = _ref.theme;
  return theme.space.m;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.space.xxs;
}, strictSpace, function (_ref3) {
  var theme = _ref3.theme;
  return theme.colors.textPrimary;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.colors.borderPrimary;
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.colors.bgSecondary;
}, mixins.fontSmoothing, function (_ref6) {
  var theme = _ref6.theme,
      variant = _ref6.variant;
  return css(["background-color:", ";"], variant === 'off' ? theme.colors.bgNegativePrimary : variant === 'pending' ? theme.colors.bgWarningPrimary : variant === 'on' ? theme.colors.bgPositivePrimary : theme.colors.borderPrimary);
});
StatusTag.displayName = 'StatusTag';
StatusTag.propTypes = _objectSpread({
  variant: PropTypes.oneOf(['on', 'pending', 'off'])
}, styledPropTypes.space);
/** @component */

export default StatusTag;